module.exports = __webpack_public_path__ + "img/icon_climate-controlled.65afa7ed.svg";